module.exports = "img/0.ba3268.webp";